import { render, staticRenderFns } from "./MessageSender.vue?vue&type=template&id=fb0c142e&scoped=true"
import script from "./MessageSender.vue?vue&type=script&lang=js"
export * from "./MessageSender.vue?vue&type=script&lang=js"
import style0 from "./MessageSender.vue?vue&type=style&index=0&id=fb0c142e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0c142e",
  null
  
)

export default component.exports